export enum UserRoleTypes {
  SuperAdministrator = "SuperAdministrator", //ADM IP
  TenantManager = "TenantManager", // ADM
  ExternalManager = "ExternalManager", // ADM EXT
  Audit = "Audit", //Auditoria *
  Tester = "Tester", // Interface *
  Manager = "Manager", // Gestor interno *
  CompanyManager = "CompanyManager", // Gestor cliente *
}
